import { Navbar, Nav, NavDropdown, Container, Badge } from 'react-bootstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import './navBar.css';

const NavBar = ({ auth, onLogout }) => {
    const navigate = useNavigate();
    const user = auth?.user; // Safe access to auth.user

    const getUserInitials = () => {
        if (!user) return '';
        if (user.name && user.name.includes(' ')) {
            return user.name
                .split(' ')
                .map(part => part[0].toUpperCase())
                .join('')
                .substring(0, 2);
        }
        return user.name ? user.name.charAt(0).toUpperCase() :
            user.email ? user.email.charAt(0).toUpperCase() : '';
    };

    const handleLogout = () => {
        onLogout();
        navigate('/login');
    };

    const renderRoleBadge = () => {
        if (!user?.role) return null;
        return (
            <Badge pill bg={user.role === 'admin' ? 'danger' : 'primary'} className="ms-2 role-badge">
                {user.role}
            </Badge>
        );
    };

    return (
        <Navbar bg="white" expand="lg" className="navbar-custom shadow-sm">
            <Container fluid>
                <Navbar.Brand as={NavLink} to="/" className="d-flex align-items-center">
                    <span className="brainlink-heading me-2">BrainLink</span>
                </Navbar.Brand>

                <div className="d-flex align-items-center">
                    <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-0">
                        <span className="navbar-toggler-icon-custom"></span>
                    </Navbar.Toggle>
                </div>

                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto ms-3">
                        {auth?.isAuthenticated && user?.role === 'admin' ? (
                            <Nav.Link as={NavLink} to="/" className="nav-link-custom"> User Management </Nav.Link>
                        ) : (
                            <Nav.Link as={NavLink} to="/dashboard" className="nav-link-custom"> Dashboard </Nav.Link>
                        )}
                        <Nav.Link as={NavLink} to="/device" className="nav-link-custom"> Devices </Nav.Link>
                        <Nav.Link as={NavLink} to="/measurement" className="nav-link-custom"> Measurements </Nav.Link>
                        <Nav.Link as={NavLink} to="/measurement-categories" className="nav-link-custom"> Measurement Types </Nav.Link>
                        <Nav.Link as={NavLink} to="/sensor" className="nav-link-custom"> Sensors </Nav.Link>
                        <Nav.Link as={NavLink} to="/rawTable" className="nav-link-custom"> Log Data </Nav.Link>
                    </Nav>

                    {auth?.isAuthenticated && user && (
                        <Nav className="align-items-center">
                            {/* Desktop View - Dropdown */}
                            <div className="d-none d-lg-block">
                                <NavDropdown
                                    title={
                                        <div className="d-flex align-items-center user-dropdown-toggle">
                                            <div className="user-avatar me-2">
                                                {getUserInitials()}
                                            </div>
                                        </div>
                                    }
                                    id="user-dropdown"
                                    align="end"
                                    className="user-dropdown"
                                >
                                    <div className="dropdown-header px-3 py-2">
                                        <div className="d-flex align-items-center">
                                            <div className="user-avatar-lg me-3"> {getUserInitials()} </div>
                                            <div>
                                                <div className="fw-bold">{user?.name || 'User'}</div>
                                                <div className="text-muted small">{user?.email}</div>
                                                {renderRoleBadge()}
                                            </div>
                                        </div>
                                    </div>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item as={NavLink} to="/profile" className="dropdown-item-custom">
                                        <FontAwesomeIcon icon={faUser} className="me-2" />
                                        Profile
                                    </NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item
                                        onClick={handleLogout}
                                        className="dropdown-item-custom text-danger"
                                    >
                                        <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                                        Logout
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </div>

                            {/* Mobile View - Direct Links */}
                            <div className="d-lg-none mobile-user-menu">
                                <div className="d-flex align-items-center">
                                    <div className="user-avatar me-2"> {getUserInitials()} </div>
                                    <div className="mobile-user-links">
                                        <Nav.Link as={NavLink} to="/profile" className="mobile-user-link">
                                            <FontAwesomeIcon icon={faUser} className="me-2" />
                                            Profile
                                        </Nav.Link>
                                        <Nav.Link onClick={handleLogout} className="mobile-user-link text-danger">
                                            <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                                            Logout
                                        </Nav.Link>
                                    </div>
                                </div>
                            </div>
                        </Nav>
                    )}
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default NavBar;